import { render, staticRenderFns } from "./DealershipPinRecord.vue?vue&type=template&id=2c2f59f5&"
import script from "./DealershipPinRecord.vue?vue&type=script&lang=js&"
export * from "./DealershipPinRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports